var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thmbUp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 88.9",
    style: {
      enableBackground: "new 0 0 100 88.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "col-stroke_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "col-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,42.2c0-5.5-4.5-10-10-10H63.8c2.7-5.6,2.7-11.8,2.7-16.3v-0.5c0-4.4-2.3-10.8-6.6-13.7 C57.5,0,54.7-0.4,52,0.6c-3.6,1.3-4.3,5.2-5,9.7c-1.4,8.5-3.5,21.3-23.9,30.4v-2.5c0-1.8-1.4-3.2-3.2-3.2H3.2 C1.4,35,0,36.4,0,38.2v47.5c0,1.8,1.4,3.2,3.2,3.2h16.7c1.8,0,3.2-1.4,3.2-3.2v-1c6,0,11,1.2,15.5,2.3c3.6,0.9,7.1,1.7,10.4,1.7 h33.2c5,0,9.1-4.1,9.1-9.1c0-1.5-0.4-2.9-1-4.1c2.7-1.6,4.5-4.5,4.5-7.8c0-1.4-0.3-2.7-0.9-3.9c3.1-1.6,5.2-4.7,5.2-8.4 c0-2.3-0.8-4.4-2.2-6.1C98.8,47.5,100,45,100,42.2z M12.4,82.3c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9 C16.2,80.6,14.5,82.3,12.4,82.3z M89.7,58.7h-4c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1c1.6,0,2.9,1.3,2.9,2.9 s-1.3,2.9-2.9,2.9h-3.5c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9H49c-2.6,0-5.5-0.7-9-1.6 c-4.8-1.2-10.2-2.5-16.9-2.5V47.4c0.1,0,0.2,0,0.2-0.1c25.6-10.5,28.3-27.1,29.8-36c0.3-1.8,0.7-4.3,1.2-5 c0.5-0.2,1.2-0.2,2.1,0.4c2.1,1.5,3.9,5.5,3.9,8.7v0.5c0,5.3,0,12.4-4.5,17.3c-0.8,0.9-1.1,2.2-0.6,3.3s1.6,1.9,2.8,1.9h32 c2.1,0,3.8,1.7,3.8,3.8S92.1,46,90,46l0,0l0,0c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1s3,1.4,3,3.2 C92.9,57.2,91.5,58.7,89.7,58.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingUp);
export default __webpack_public_path__ + "static/media/rating-up.27240d2d.svg";
export { ForwardRef as ReactComponent };